module.exports = __webpack_public_path__ + "img/西瓜13.4cb048e4.png";